
<style scoped>
    .wizard-side-component {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        background-color: white;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        width: 350px;
        box-shadow: 0 2px 6px 0 rgba(0,0,0,.2)
    }

    .wizard-side-component.collapsed {
        box-shadow: none;
        width: 25px;
    }
    .wizard-side-component.collapsed .fa-icon {
        float: right;
    }

    .wizard-side-component .clickable {
        cursor: pointer;
    }
    .expand-button, .wizard-side-component-title {
        font-size: 120%;
        font-weight: bold;
        text-align: center;
        padding: 10px;
        margin: 5px 0;
    }

    .expand-button {
        flex-grow: 1;
    }
    .wizard-side-component .collapse-button {
        float: right;
    }
</style>
<template>
    <div class="wizard-side-component" v-bind:class="{ 'should-be-fixed': shouldBeFixed, 'collapsed' : isCollapsed }">
        <div v-if="isCollapsed" class="expand-button clickable" @click.stop="expand()" title="Profile Health Component">
            <icon name="angle-double-left"></icon>
        </div>
        <div v-if="!isCollapsed" class="wizard-side-component-title">
            <span @click.stop="collapse()" class="collapse-button clickable" title="collapse">
                <icon name="angle-double-right"></icon>
            </span>
            Profile Health
        </div>
        <profile-health-component v-show="!isCollapsed" :profile-guid="(isGuidSet)? profileGuid : ''" ref="profileHealthComponent"></profile-health-component>
    </div>
</template>
<script>
    import ProfileHealthComponent from "./ProfileHealth";
    import 'vue-awesome/icons/angle-double-right';
    import 'vue-awesome/icons/angle-double-left';
    import Icon from 'vue-awesome/components/Icon.vue';
    import { mapActions } from 'vuex';
    import {
        PREFIX as APP_PREFIX,
        NAMESPACE as APP_NAMESPACE
    } from '../store/modules/app.js';

    const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

    export default {
        props: [
            'profileGuid'
        ],
        data() {
            return {
                'isCollapsed': false,
                'shouldBeFixed': false,
                currentWizardStep: null
            }
        },
        computed: {
            isGuidSet() {
                return this.profileGuid && this.profileGuid !== EMPTY_GUID;
            },
            windowWidth() {
                return window.innerWidth;
            }
        },
        created: function() {
            window.addEventListener('scroll', () => {
                this.adjustElementPosition()
            });
            this.adjustElementPosition();
        },
        methods: {
            ...mapActions({
                registerListener: APP_NAMESPACE.actions.ADD_LISTENER
            }),
            adjustElementPosition() {
                if (typeof($) === "undefined") {
                    return;
                }
                adjutDivPositionOnPage($(this.$el), this);
            },
            collapse() {
                this.isCollapsed = true;
                this.adjustElementPosition();
            },
            expand() {
                this.isCollapsed = false;
                this.adjustElementPosition();
            },
            handleNotification(notification) {
                if (notification.profileDataToOverride !== undefined) {
                    this.$refs.profileHealthComponent.refresh(
                        notification.profileDataToOverride
                    );
                }
                if (notification.wizardStep !== undefined) {
                    refreshOnStepChange(this.currentWizardStep, this.$refs.profileHealthComponent);
                    this.currentWizardStep = notification.wizardStep;
                }
            }
        },
        components: {
            'profile-health-component': ProfileHealthComponent,
            'icon': Icon
        },
        mounted: function() {
            this.registerListener({
                on: 'WizardSide',
                handler: function(notification) {
                    this.handleNotification(notification);
                }.bind(this)
            });
        }
    }

    const refreshOnStepChange = function(oldStep, healthComponent) {
        switch (oldStep) {
            case 'jira-connection-step':
            case 'tfs-connection-step':
            case 'synchronization-settings':
                healthComponent.refresh();
        }
    };

    const adjutDivPositionOnPage = function($element, vueComponent) {
        if ($('.tabheader').length > 0) {
            const sideComponentPosY = $('.tabheader').offset().top;
            let isSideComponentPositionFixed = false;
            const isScrolledBellowSideComponent = $(window).scrollTop() > (sideComponentPosY + 50);
            if (isScrolledBellowSideComponent !== isSideComponentPositionFixed) {
                isSideComponentPositionFixed = isScrolledBellowSideComponent;
            }
            vueComponent.shouldBeFixed = isSideComponentPositionFixed;
            if (vueComponent.shouldBeFixed) {
                $element.css('right', $(window).width() - $('.page').offset().left - $('.page').outerWidth());
            } else {
                $element.css('right', 'auto');
            }
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/WizardSide.vue